"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FifoMap = void 0;
class FifoMap {
    maxSize;
    orderedKeys = [];
    map = new Map();
    constructor(maxSize) {
        this.maxSize = maxSize;
    }
    set(key, value) {
        // Only add the key to our order queue if it's new
        if (!this.map.has(key)) {
            this.orderedKeys.push(key);
            // If we're over capacity, remove the oldest entry
            if (this.orderedKeys.length > this.maxSize) {
                const oldestKey = this.orderedKeys.shift();
                if (oldestKey !== undefined) {
                    this.map.delete(oldestKey);
                }
            }
        }
        this.map.set(key, value);
        return this;
    }
    get(key) {
        return this.map.get(key);
    }
    has(key) {
        return this.map.has(key);
    }
    delete(key) {
        if (this.map.delete(key)) {
            const index = this.orderedKeys.indexOf(key);
            if (index !== -1) {
                this.orderedKeys.splice(index, 1);
            }
            return true;
        }
        return false;
    }
    clear() {
        this.map.clear();
        this.orderedKeys = [];
    }
    get size() {
        return this.map.size;
    }
    // The entries method returns an iterator of key-value pairs in FIFO order.
    *entries() {
        for (const key of this.orderedKeys) {
            // We can safely use the non-null assertion here since all keys in orderedKeys should be in the map
            yield [key, this.map.get(key)];
        }
    }
    // Optional: making the FifoMap itself iterable.
    [Symbol.iterator]() {
        return this.entries();
    }
}
exports.FifoMap = FifoMap;
//# sourceMappingURL=fifoImpl.js.map